import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import { cn } from "@/shared/libs/commonUtils";
import { useTheme } from "next-themes";
export default function ThemeSwitch() {
  const {
    theme,
    setTheme
  } = useTheme();
  const darkMode = theme === "dark";
  const changeTheme = () => setTheme(theme === "dark" ? "light" : "dark");
  return <Flex onClick={changeTheme} alignItems={"center"} justifyContent={"center"} className={cn("w-8 h-8 ring-1 bg-background/10 rounded-full relative cursor-pointer", darkMode ? "ring-muted/30" : "ring-ring")} data-sentry-element="Flex" data-sentry-component="ThemeSwitch" data-sentry-source-file="ThemeSwitch.tsx">
      <PhosphorIcon name={darkMode ? "SunDim" : "Moon"} size={22} className={cn(darkMode ? "text-foreground" : "text-foreground")} data-sentry-element="PhosphorIcon" data-sentry-source-file="ThemeSwitch.tsx" />
    </Flex>;
}